import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { Helmet } from 'react-helmet';
import metaImage from '../assets/images/navBackgrounds/property-macromenu.jpg';

export default function SEO({ children, location, description, title, image }) {
  const {
    site: { siteMetadata },
  } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          siteUrl
          twitter
        }
      }
    }
  `);
  return (
    <Helmet>
      <html lang="en" />
      <title>{title}</title>
      {/* Favicons */}
      <link
        rel="icon"
        type="image/svg+xml"
        href={`${siteMetadata.siteUrl}/favicon.svg`}
      />
      <link rel="alternate icon" href={`${siteMetadata.siteUrl}/favicon.ico`} />
      {/* Meta tags */}
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <meta charSet="utf-8" />
      <meta
        name="description"
        content={description || siteMetadata.description}
      />
      {/* Open Graph */}
      {location && <meta property="og:url" content={location.href} />}
      <meta
        property="og:image"
        content={image || `${siteMetadata.siteUrl}${metaImage}`}
      />
      <meta
        property="og:title"
        content={title || siteMetadata.title}
        key="ogtitle"
      />
      <meta
        property="og:site_name"
        content={siteMetadata.title}
        key="ogsitename"
      />
      <meta
        property="og:description"
        content={description || siteMetadata.description}
        key="ogdesc"
      />
      {/* Get Site Control */}
      <script
        type="text/javascript"
        async
        src="//l.getsitecontrol.com/xwke2vdw.js"
      />
      {/* Widget tracker */}
      <Helmet>
        <script>
          {`
            (function(w,i,d,g,e,t){w["WidgetTrackerObject"]=g;(w[g]=w[g]||function()
            {(w[g].q=w[g].q||[]).push(arguments);}),(w[g].ds=1*new Date());(e="script"),
            (t=d.createElement(e)),(e=d.getElementsByTagName(e)[0]);t.async=1;t.src=i;
            e.parentNode.insertBefore(t,e);})
            (window,"https://widgetbe.com/agent",document,"widgetTracker");
            window.widgetTracker("create", "WT-IKKJZRCX");
            window.widgetTracker("send", "pageview");
          `}
        </script>
      </Helmet>
      {/* Google analytics && Hotjar included through Gatsby plugins – see gatsby-config.js */}
      {/* Allow additional tags to be inject on a per-page basis */}
      {children}
    </Helmet>
  );
}
